<div class="tab-content">
  <div class="tab-header-row">
    <h2>Customer Audit History</h2>
  </div>

  <rms-table [data]="AuditEntries" [columns]="Columns"></rms-table>
</div>
